import { useState } from "react";
import { Copy, CheckCircle, Loader2 } from "lucide-react";
import { toast } from "react-hot-toast";
import BottomNav from "../components/BottomNav";

const WALLET_ADDRESS = "0xeF8108E2956f85371919d6a089F5b9CA712B6D5b";

export default function CardPage() {
  const [copied, setCopied] = useState(false);
  const [loading, setLoading] = useState(false);
  const [paid, setPaid] = useState(false);

  // ──────────────────────────────────────
  // Copy address
  // ──────────────────────────────────────
  const copyAddress = async () => {
    try {
      await navigator.clipboard.writeText(WALLET_ADDRESS);
      setCopied(true);
      toast.success("Address copied!");
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      toast.error("Failed to copy");
    }
  };

  // ──────────────────────────────────────
  // Simulate payment confirmation
  // ──────────────────────────────────────
  const handlePaid = () => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setPaid(true);
      toast.success("Payment Confirmation pending: Check your email in 24hrs.");
    }, 2000);
  };

  return (
    <>
      {/* ────── Page (with safe bottom padding) ────── */}
      <div className="min-h-screen bg-gradient-to-br from-gray-50 to-white pt-20 pb-24 px-4">
        <div className="max-w-2xl mx-auto">
          <div className="bg-white rounded-2xl shadow-xl p-8 text-center">

            {/* Title */}
            <h1 className="text-3xl font-bold text-primary mb-6">
              Purchase Master PIN Credit Card
            </h1>

            {/* Description */}
            <p className="text-gray-700 mb-8 leading-relaxed">
              To activate your <strong>Master PIN Credit Card</strong>, make a
              one‑time payment of
              <br />
              <span className="text-2xl font-bold text-primary">$5,000 USDT</span>
              <br />
              to the wallet address below.
            </p>

            {/* Wallet address + copy */}
            <div className="mb-8">
              <div className="flex items-center gap-2 bg-gray-50 border border-gray-200 rounded-xl p-4">
                <input
                  type="text"
                  value={WALLET_ADDRESS}
                  readOnly
                  className="flex-1 bg-transparent outline-none font-mono text-sm"
                />
                <button
                  onClick={copyAddress}
                  className="p-2 hover:bg-gray-200 rounded-lg transition"
                  aria-label="Copy address"
                >
                  {copied ? (
                    <CheckCircle className="w-5 h-5 text-green-600" />
                  ) : (
                    <Copy className="w-5 h-5 text-gray-600" />
                  )}
                </button>
              </div>
              <p className="text-xs text-gray-500 mt-2">
                Only send <strong>USDT (ERC‑20)</strong> to this address.
              </p>
            </div>

            {/* I have paid button / success */}
            {!paid ? (
              <button
                onClick={handlePaid}
                disabled={loading}
                className={`
                  w-full py-4 rounded-xl font-bold text-white flex items-center justify-center gap-2
                  transition-all
                  ${loading ? "bg-gray-400" : "bg-primary hover:bg-primary/90 shadow-lg"}
                `}
              >
                {loading ? (
                  <>
                    <Loader2 className="w-5 h-5 animate-spin" />
                    Processing...
                  </>
                ) : (
                  "I have paid"
                )}
              </button>
            ) : (
              <div className="bg-green-50 border border-green-200 rounded-xl p-6">
                <CheckCircle className="w-12 h-12 text-green-600 mx-auto mb-3" />
                <p className="text-lg font-semibold text-green-800">
                  Awaiting confirmation... Your payment is under review.
                </p>
                <p className="text-sm text-green-700 mt-2">
                  You will receive your Master PIN via email within the next{" "}
                  <strong>24 hours</strong>.
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
        <BottomNav />
    </>
  );
}